"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagText = exports.StyledTag = exports.Info = exports.Item = exports.Title = exports.Heading = exports.SimilarOfferBox = exports.CustomPanel = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importStar(require("styled-components"));
exports.CustomPanel = (0, styled_components_1.default)(elements_1.Panel) `
	padding: 1rem;
	margin-bottom: 1rem;
	${({ arePromotedOffers }) => arePromotedOffers &&
    (0, styled_components_1.css) `
			border: 1px solid ${({ theme }) => theme.color.premium};
		`}
`;
exports.SimilarOfferBox = styled_components_1.default.aside `
	display: flex;
	flex-direction: column;
	align-items: center;
`;
exports.Heading = styled_components_1.default.h5 `
	font-size: 1.2rem;
	text-align: center;
	margin-bottom: 1rem;
	display: flex;
	align-items: center;

	${({ arePromotedOffers }) => arePromotedOffers &&
    (0, styled_components_1.css) `
			padding: 0.25rem 0.75rem;
			border-radius: ${({ theme }) => theme.borderRadius.base};
			background-color: ${({ theme }) => theme.color.premium};
			color: ${({ theme }) => theme.color.white};
			width: fit-content;
		`}
`;
exports.Title = styled_components_1.default.p `
	font-size: 1rem;
	margin-bottom: 0.5rem;
	line-height: 1rem;
`;
exports.Item = (0, styled_components_1.default)(elements_1.Link) `
	border-bottom: 1px solid ${({ theme }) => theme.color.gray4};
	padding: 0.75rem;
	width: 100%;

	&:hover {
		background: ${({ theme }) => theme.color.gray1};
		transition: 0.167s;
	}
	&:last-child {
		border-bottom: none;
	}
`;
exports.Info = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.black};
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 0.8rem;
	width: 100%;
	white-space: normal;
	flex-wrap: wrap;
	justify-content: space-between;
	gap: 0.5rem;

	svg {
		height: 14px;
		width: 14px;
		min-width: 14px;
	}
`;
exports.StyledTag = (0, styled_components_1.default)(elements_1.Tag) ``;
exports.TagText = styled_components_1.default.div `
	white-space: normal;
	word-wrap: break-word;
`;
